import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { gluteImages, gluteProduct } from '../../data/gluteCopy';
export function GluteHero() {
  return <header className="w-full bg-coal text-white" data-id="element-48" data-mp="3mjodpi1xx5h4">
      <div className="mx-auto w-full max-w-6xl px-5 pb-14 pt-10 sm:px-8 sm:pb-20 sm:pt-14 lg:pb-28 lg:pt-20" data-id="element-49" data-mp="3rihrlbl52yht">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-50" data-mp="3drcmhtz05e03">
          <div data-id="element-51" data-mp="3iiun2gx45ckj">
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-52" data-mp="3ije6y36bqb17">
              Método de 21 días
            </p>

            <h1 className="mt-5 text-[2.2rem] font-extrabold uppercase leading-[0.94] tracking-tight sm:text-6xl lg:text-[4.1rem]" data-id="element-53" data-mp="33rlsdtect10j">
              Glute Lab
              <span className="mt-1 block text-ember" data-id="element-54" data-mp="2uu1qci8o30ov">El Código del Crecimiento</span>
            </h1>

            <p className="mt-6 max-w-lg text-[1.02rem] leading-relaxed text-white/60 sm:text-lg" data-id="element-55" data-mp="2yt277v7l3t98">
              El Protocolo <span className="font-semibold text-white" data-id="element-56" data-mp="3b4hr3tjcqhz0">“Unlock”</span> neuromuscular:
              pre-activación y pausas isométricas que obligan a tu sistema nervioso a despertar el
              glúteo que tu entrenamiento actual está ignorando.
            </p>

            <div className="mt-8 flex flex-col items-stretch gap-3 sm:mt-10 sm:flex-row sm:items-center sm:gap-5" data-id="element-57" data-mp="3g4w1vjcc860q">
              <CtaButton tone="ember" label="Quiero el método" scrollToId="precio-glute" data-id="element-58" data-mp="2sgcrmy9q9j60" />
              <p className="text-center text-sm text-white/50 sm:text-left" data-id="element-59" data-mp="2nhjbsz6yxg2o">
                Precio de lanzamiento{' '}
                <span className="font-semibold text-white" data-id="element-60" data-mp="326xn4cu3u7kp">
                  ${gluteProduct.guidePrice.toFixed(2)}
                </span>{' '}
                · pago único
              </p>
            </div>

            <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[0.8rem] text-white/40 sm:mt-10 sm:justify-start sm:text-sm" data-id="element-61" data-mp="29n8xlbsll4av">
              <li className="inline-flex items-center gap-2" data-id="element-62" data-mp="2uenvhhja9h14">
                <DownloadIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-63" data-mp="2uc1opk47v5jy" />
                Acceso inmediato
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-64" data-mp="335xx7w4gkjgw">
                <LockIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-65" data-mp="338j10qobh9ha" />
                Pago seguro
              </li>
            </ul>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="order-first lg:order-none" data-id="element-66" data-mp="2bgbmbvsdg75j">
            <img src={gluteImages.training} alt="Entrenamiento de glúteo en un gimnasio boutique con iluminación cálida" className="aspect-[4/5] w-full rounded-2xl object-cover sm:aspect-[3/2] lg:aspect-[4/5]" width={1200} height={800} data-id="element-67" data-mp="2kib4irf4hha2" />
          </motion.div>
        </div>
      </div>
    </header>;
}